import { Timeout } from './SnackbarUtils';
import Snackbar from './Snackbar';

// #region COMMON

const initialize = (syncTasks, asyncTasks, currentMessage, showExpanded) => {
  const initialState = {
    operazioni: syncTasks,
    operazioniMassive: asyncTasks,
    current: currentMessage,
    expand: showExpanded,
  };

  Snackbar.inizializzaOperazioni(initialState);
};

const clear = () => {
  Snackbar.clear();
};

// #endregion

// #region SYNC FUNCTIONS

const notifySuccess = (message, confirm, timeout) => {
  const task = {
    type: Snackbar.Types.SUCCESS,
    message,
    timeout: timeout || Timeout.SHORT,
    confirm: confirm || false,
  };

  Snackbar.show(task);
};

const notifyError = (notifyMessage, confirm, timeout) => {
  const message = Array.isArray(notifyMessage) ? notifyMessage.join(' ') : notifyMessage;

  const task = {
    type: Snackbar.Types.ERROR,
    message,
    timeout: timeout || Timeout.LONG,
    confirm: confirm || true,
  };

  Snackbar.show(task);
};

const notifyWarning = (message, confirm, timeout) => {
  const task = {
    type: Snackbar.Types.WARNING,
    message,
    timeout: timeout || Timeout.SHORT,
    confirm: confirm || false,
  };

  Snackbar.show(task);
};

// #endregion

// #region ASYNC FUNCTIONS

const startDeterminateAsyncTask = (taskCorrelationId, taskName, operations) => {
  const task = {
    type: Snackbar.Types.MASSIVA,
    id: taskCorrelationId,
    message: taskName,
    selezionati: operations,
  };

  Snackbar.creaOperazioneMassiva(task);

  return taskCorrelationId;
};

const startIndeterminateAsyncTask = (taskCorrelationId, taskName) => {
  const task = {
    type: Snackbar.Types.MASSIVA,
    id: taskCorrelationId,
    message: taskName,
    selezionati: false,
  };

  Snackbar.creaOperazioneMassiva(task);

  return taskCorrelationId;
};

const updateDeterminateAsyncTaskProgress = (taskCorrelationId, progress) => {
  Snackbar.aggiornaProgressoOperazione(taskCorrelationId, progress);
};

const notifyAsyncTaskError = (taskCorrelationId, message, content) => {
  const error = {
    message,
    content,
  };
  Snackbar.aggiungiErroreAOperazione(taskCorrelationId, error);
};

const getAsyncTasks = () => Snackbar.recuperaOperazioniMassive();

const completeAsyncTask = (taskCorrelationId, progress, feedbackText, feedbackCallback) => {
  Snackbar.terminaOperazioneMassiva(taskCorrelationId, progress, feedbackText, feedbackCallback);
};

// #endregion

const SnackbarWrapper = {
  clear,
  completeAsyncTask,
  getAsyncTasks,
  initialize,
  notifyAsyncTaskError,
  notifyError,
  notifySuccess,
  notifyWarning,
  startDeterminateAsyncTask,
  startIndeterminateAsyncTask,
  updateDeterminateAsyncTaskProgress,
};

export default SnackbarWrapper;
